import { PageLayoutAtom } from '@justomx/atlas-components'
import { AtlasDesignSystemProvider } from '@justomx/atlas-design-system'
import { setProductionUrls } from '@justomx/webview-commons'
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import {
  I18nextProvider,
  initReactI18next,
  useTranslation
} from 'react-i18next'
import { RouterProvider } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { createGlobalStyle, StyleSheetManager } from 'styled-components'
import 'react-toastify/dist/ReactToastify.css'
import '@justomx/atlas-design-system/dist/style.css'

import esGlobal from './i18n/es/global.json'
import brGlobal from './i18n/pt_BR/global.json'
import { router } from './pages/router'
import './analytics/analytics.utils'

setProductionUrls([
  'https://staging.op-consolidation-wv.pages.dev',
  'https://op-consolidation-wv.pages.dev'
])

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    interpolation: { escapeValue: false },
    lng: 'es',
    resources: {
      es: { global: esGlobal },
      pt: { global: brGlobal }
    }
  })
  .catch((err) => {
    console.error(err)
  })

const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    font-style: normal;
    font-weight: 400;
  }
`

declare global {
  interface Window {
    WVMetadata?: Record<string, string>
  }
}

export function App() {
  const { i18n } = useTranslation('global')

  return (
    <I18nextProvider i18n={i18n}>
      <AtlasDesignSystemProvider>
        <StyleSheetManager>
          <GlobalStyle />
          <PageLayoutAtom>
            <RouterProvider router={router} />
          </PageLayoutAtom>
          <ToastContainer
            theme="dark"
            position="bottom-center"
            toastClassName="toastErrorClass"
          />
        </StyleSheetManager>
      </AtlasDesignSystemProvider>
    </I18nextProvider>
  )
}
